module.exports = __webpack_public_path__ + "img/lock.9bb6f61a.png";